const utils = require('../../../lib/utils');

module.exports = {
	config: {
		preventFieldChangeOnInit: false
	},

	model: {
		$options: {},
		colors: {},
		keyDownLabel: '',

		config: {
			// default: undefined,	// if no value could be selected by default, this one will be used. e.g., category-picker-toggles get their default value via isDefault flag of the corresponding categoryData entry.
			// strict: false, 		// special flag for boolean toggles with static values. usually filters need some kind of (null, 1, 0) <=> (All, Yes, No). in strict mode there are only (1, 0) <=> (Yes, No)
			// colors: {}, 			// NOTE: this is just a way to define model.colors and ist used to render different options within the same toggle in different colors. this list has the following potential format: {<optionValue>: {
									//		color: '#FFFFFF',
									//		fontColor: '#FFFFFF',
									//		activeColor: '#FFFFFF',
									//		hoverColor: '#FFFFFF',
									//		complementaryColor: '#FFFFFF',
									// }}

			// slimSwitch: false, 			// renders a little toggle without content or names. inspired by bootstrap switches. @see https://getbootstrap.com/docs/5.3/forms/checks-radios/#switches
			// singleButtonSwitch: false, 	// renders one single button instead of all toggle options which may switch on click to the next option.
			// reverseSwitchOrder: false, 	// fieldConfig.slimSwitch or fieldConfig.singleButtonSwitch allow to reverse the click order
		}
	},

	events: {
		toggle: {
			type: 'click',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				const self = event.data.component

				let $target, value;
				if(($target = $(event.target).closest('.toggleOption')).length > 0){
					value = $target.data('value');
					self.select(value, $target.hasClass('disabled'));
				}
				else {
					self.toggle()
				}
			}
		},

		hoverIn: {
			type: 'mouseenter',
			selector: "[data-value]",
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('[data-value]');
				if($target.length > 0){
					var value = $target.data('value');
					if(value !== undefined && (self.model.colors[value] || {}).hoverColor){
						$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].hoverColor);
						$target.css('color', self.model.colors[value].complementaryColor);
					}
				}
			}
		},
		hoverOut: {
			type: 'mouseleave',
			selector: "[data-value]",
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('[data-value]');
				if($target.length > 0){
					var value = $target.data('value');
					// prevent color reset in case no hover color has been defined
					if(value !== undefined && (self.model.colors[value] || {}).hoverColor){
						if($target.hasClass('selected')){
							if((self.model.colors[value] || {}).activeColor){
								$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].activeColor);
								$target.css('color', self.model.colors[value].complementaryColor);
							}
						} else if((self.model.colors[value] || {}).color){
							$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].color);
							$target.css('color', self.model.colors[value].fontColor);						}
					}
				}
			}
		},
	},

	methods: {
		prepare: function(storage, isServer, options){
			this.model.config = this.model.config || {};
			this.prepareMeta(storage, isServer, options);
		},

		prepareStaticOptions: function(dataType, dataFlag){
			const fieldConfig = this.model.config || {};

			if(fieldConfig.colors){
				this.model.colors = fieldConfig.colors
			}

			if(dataType === 'boolean'){
				if(fieldConfig.singleButtonSwitch){
					fieldConfig.strict = true
				}

				if(!this.model[dataFlag]){
					if(fieldConfig.strict){
						if(fieldConfig.slimSwitch){
							this.model[dataFlag] = {
								options: [
									{ name: __('dataValues.boolean.0'), value: 0, defaultSelected: !fieldConfig.default, color: ((this.model.colors || {})[0] || {}).color, config: { fontColor: ((this.model.colors || {})[0] || {}).fontColor, complementaryColor: ((this.model.colors || {})[0] || {}).complementaryColor } },
									{ name: __('dataValues.boolean.1'), value: 1, defaultSelected: fieldConfig.default, color: ((this.model.colors || {})[1] || {}).color, config: { fontColor: ((this.model.colors || {})[1] || {}).fontColor, complementaryColor: ((this.model.colors || {})[1] || {}).complementaryColor } }
								]
							};
						} else {
							this.model[dataFlag] = {
								options: [
									{ name: __('dataValues.boolean.1'), value: 1, defaultSelected: fieldConfig.default, color: ((this.model.colors || {})[1] || {}).color, config: { fontColor: ((this.model.colors || {})[1] || {}).fontColor, complementaryColor: ((this.model.colors || {})[1] || {}).complementaryColor } },
									{ name: __('dataValues.boolean.0'), value: 0, defaultSelected: !fieldConfig.default, color: ((this.model.colors || {})[0] || {}).color, config: { fontColor: ((this.model.colors || {})[0] || {}).fontColor, complementaryColor: ((this.model.colors || {})[0] || {}).complementaryColor } }
								]
							};
						}
					} else {
						this.model[dataFlag] = {
							options: [
								{ name: __('dataValues.boolean.all'), value: undefined, defaultSelected: fieldConfig.default === undefined },
								{ name: __('dataValues.boolean.1'), value: 1, defaultSelected: fieldConfig.default !== undefined && fieldConfig.default, color: ((this.model.colors || {})[1] || {}).color, config: { fontColor: ((this.model.colors || {})[1] || {}).fontColor, complementaryColor: ((this.model.colors || {})[1] || {}).complementaryColor } },
								{ name: __('dataValues.boolean.0'), value: 0, defaultSelected: fieldConfig.default !== undefined && !fieldConfig.default, color: ((this.model.colors || {})[0] || {}).color, config: { fontColor: ((this.model.colors || {})[0] || {}).fontColor, complementaryColor: ((this.model.colors || {})[0] || {}).complementaryColor } }
							]
						};
					}
				}
			}
		},

		prepareMeta: function(storage, isServer, options){
			storage = storage || window.storage
			isServer = isServer || false
			options = options || { refresh: true }
			const fieldConfig = this.model.config || {}
			const formMapping = this.formMapping || {}

			this.model.isDisabled 		= Boolean((formMapping.fieldConfig || {}).disabled || fieldConfig.disabled)
			this.model.isFilterField 	= Boolean((formMapping.fieldConfig || {}).isFilterField)

			if(!options.refresh && this.model.isFilterField && this.model.value !== this.model.filterValue){
				this.model.value = this.model.filterValue;
			}

			// prepare config
			this.model.renderConfig = (this.model.config || {}).renderConfig || {};
			this.model.childConfig = this.model.renderConfig.optionEntries || {};
			this.model.childConfig = utils.replace({ value: 'value', name: 'name', description: 'description' }, this.model.childConfig);

			// prepare user-lang
			var langCode;
			if(storage.user && storage.user.data && storage.user.data.langCode){
				langCode = storage.user.data.langCode;
			}

			// prepare data-type
			var dataType;
			if(this.model.atom && this.model.atom.dataType){
				dataType = this.model.atom.dataType;
			}

			// prepare source-data-flag
			if(dataType){
				this.model.dataAttributeKey = dataType + '-data';
			} else {
				this.model.dataAttributeKey = 'data';
			}
			this.prepareStaticOptions(dataType, this.model.dataAttributeKey);

			// prepare options
			this.model.options = [];
			if(Array.isArray(this.model[this.model.dataAttributeKey])){
				this.model.options = this.model[this.model.dataAttributeKey];
			}
			else if(!!this.model[this.model.dataAttributeKey] && !!this.model[this.model.dataAttributeKey].options){
				this.model.options = this.model[this.model.dataAttributeKey].options;
			}

			// prepare default entry
			if(this.model.renderConfig.defaultOptionEntry){
				var entry = {
					defaultSelected: true
				};
				if(langCode && this.model.renderConfig.defaultOptionEntry.lang && this.model.renderConfig.defaultOptionEntry.lang[langCode]){
					entry[this.model.childConfig.name] = this.model.renderConfig.defaultOptionEntry.lang[langCode];
					entry[this.model.childConfig.value] = this.model.renderConfig.defaultOptionEntry.value;
				}
				else {
					entry[this.model.childConfig.name] = this.model.renderConfig.defaultOptionEntry.name;
					entry[this.model.childConfig.value] = this.model.renderConfig.defaultOptionEntry.value;
				}
				this.model.options.unshift(entry);
			}

			this.model.selectedChildIndex = undefined;
			if(this.model.options) {
				var optionValue;
				var defaultSelectedChildIndex;
				var optionDisabled = false;
				var nonDisabledChildIndexes = [];
				utils.forEach(this.model.options, (child, childIndex) => {
					// define options' value
					optionValue = child[this.model.childConfig.value];
					optionDisabled = (this.model.disabledValues || {})[optionValue];
					if (!optionDisabled) {
						nonDisabledChildIndexes.push(childIndex);

						if(!this.model.colors) 							this.model.colors = {};
						if(!this.model.colors[optionValue]) 			this.model.colors[optionValue] = {};
						if(child.color) 								this.model.colors[optionValue].color 		= child.color;
						if((child.config || {}).hoverColor) 			this.model.colors[optionValue].hoverColor 	= child.config.hoverColor;
						if((child.config || {}).activeColor) 			this.model.colors[optionValue].activeColor 	= child.config.activeColor;
						if((child.config || {}).complementaryColor) 	this.model.colors[optionValue].complementaryColor 	= child.config.complementaryColor;
						if((child.config || {}).fontColor) 				this.model.colors[optionValue].fontColor 			= child.config.fontColor;
					}

					// define if option is selected
					if (Array.isArray(this.model.dataJSON)) {
						if (utils.indexOf(this.model.dataJSON, optionValue) >= 0) {
							this.model.selectedChildIndex = childIndex;
						}
					} else if (this.model.isFilterField) {
						if (dataType === 'boolean') {
							if (optionValue === this.model.filterValue) {
								this.model.selectedChildIndex = childIndex;
							}
						}
						else {
							if (optionValue == this.model.filterValue) {
								this.model.selectedChildIndex = childIndex;
							}
						}
					} else if (this.model.dataTEXT != undefined && (dataType === 'template-picker' || dataType === 'text')) {
						if (optionValue == this.model.dataTEXT) {
							this.model.selectedChildIndex = childIndex;
						}
					} else if ((dataType === 'boolean' || dataType === 'integer') && optionValue == this.model.dataINT && this.model.dataINT !== undefined) {
						this.model.selectedChildIndex = childIndex;
					} else if (this.model.value === optionValue && optionValue !== undefined) {
						this.model.selectedChildIndex = childIndex;
					}
					// fieldConfig.default overrules categoryData.defaultSelected
					else if(fieldConfig.default !== undefined) {
						if(fieldConfig.default === optionValue){
							defaultSelectedChildIndex = childIndex;
						}
					} else {
						if (!!child.defaultSelected && !optionDisabled) {
							defaultSelectedChildIndex = childIndex;
						}
					}
				});

				// check if selected values are disabled
				var selectedIsDisabled = false;
				var defaultSelectedIsDisabled = false;
				if(this.model.selectedChildIndex !== undefined){
					selectedIsDisabled = (this.model.disabledValues || {})[this.model.options[this.model.selectedChildIndex][this.model.childConfig.value]];
				}
				if(defaultSelectedChildIndex !== undefined){
					defaultSelectedIsDisabled = (this.model.disabledValues || {})[this.model.options[defaultSelectedChildIndex][this.model.childConfig.value]];
				}

				// select right value
				if (this.model.selectedChildIndex !== undefined && !selectedIsDisabled) {
					defaultSelectedChildIndex = undefined;
				}
				else if (defaultSelectedChildIndex !== undefined && !defaultSelectedIsDisabled) {
					this.model.selectedChildIndex = defaultSelectedChildIndex;
				} else if (nonDisabledChildIndexes.length > 0) {
					this.model.selectedChildIndex = nonDisabledChildIndexes[0];
				} else {
					this.model.selectedChildIndex = undefined;
				}

				// save new selection if it has changed
				if(this.model.selectedChildIndex !== undefined){
					var newValue = this.model.options[this.model.selectedChildIndex][this.model.childConfig.value];
					if(this.model.value != newValue){
						this.model.value = newValue;
						// usually this is necessary to initialize default values defined by the toggle-resource-data instead of the form it is located in.
						// e.g., if a category-picker loads cms_categoryData-records including one which has been declared as default-element within its cms_category the parent form knows nothing about it until this toggle triggers this onChildChanged.
						// this is especially useful if the form is one without resourceConnection like a filter form which has no information about its potential attributes, but which may be mandatory to load the correct data in e.g., a table nearby.
						if(!isServer && !this.config.preventFieldChangeOnInit){
							this.parent(parentComponent => {
								parentComponent.trigger('onChildChanged', {
									fieldCode:  this.model.fieldCode,
									value:      newValue
								});
							});
						}
					}
				}
			}
		},

		select: function(value, fieldIsDisabled, preventCascade = false){
			if(this.model.isDisabled || fieldIsDisabled) return;
			const fieldConfig 	= this.model.config || {}
			const atom 			= this.model.atom || {}

			if(atom.dataType === 'boolean'){
				if(value === '')	value = undefined;
				else                value = parseInt(value);
			}

			if(this.model.value !== value){
				// prevent non-granted dirty values if necessary
				if(!utils.isEmpty(fieldConfig.grantDirtyValues) && !fieldConfig.grantDirtyValues[value]) return;

				if(utils.isEmpty(this.model.$options)){
					this.model.$options = this.$.find('.toggleOption');
				}

				var $toggleOption;
				if(
					utils.isFunction((this.model.$options || {}).filter) &&
					(
						($toggleOption = this.model.$options.filter('[data-value="' + value + '"]')).length > 0 ||
						((value === null || value === undefined) && ($toggleOption = this.model.$options.filter('[data-value=""], :not([data-value])')).length > 0)
					)
				){
					// reset color of actual selected toggle if necessary
					var $previouslySelectedToggle = this.model.$options.filter('.selected');
					if($previouslySelectedToggle.length > 0){
						var previousValue = $previouslySelectedToggle.data('value');
						if(previousValue !== undefined && ((this.model.colors || {})[previousValue] || {}).color){
							$previouslySelectedToggle[0].style.setProperty('--toggle-bg-color', this.model.colors[previousValue].color);
							$previouslySelectedToggle.css('color', this.model.colors[previousValue].fontColor);
						}
					}

					if(value === '' || value === undefined) value = null;
					this.model.value = value;
					this.model.$options.removeClass('selected');
					$toggleOption.addClass('selected');

					var optionIndex;
					for(optionIndex in this.model.options || []){
						if(this.model.options[optionIndex].value === value){
							this.model.selectedChildIndex = optionIndex;
							break;
						}
					}

					this.$
						.attr('data-selected-child-index', this.model.selectedChildIndex)
						[0].style.setProperty('--toggle-selected-child-index', this.model.selectedChildIndex)

					// set right value flag
					if (Array.isArray(this.model.dataJSON)) {
						this.model.dataJSON = [value];
					} else if (this.model.isFilterField) {
						this.model.filterValue = value;
					} else if (this.model.dataTEXT != undefined && (atom.dataType === 'template-picker' || atom.dataType === 'text')) {
						this.model.dataTEXT = value
					} else if (atom.dataType === 'boolean') {
						this.model.dataINT = value;
					}

					this.updateKeyDownLabelValue(value);

					this.parent(parentComponent => {
						parentComponent.trigger('onChildChanged', {
							fieldCode:  this.model.fieldCode,
							value:      value
						});
					});
				}
			}
			// toggle to next value if possible
			else if (!preventCascade && (fieldConfig.slimSwitch || fieldConfig.singleButtonSwitch)){
				const nrOfOptions = this.model.options.length
				let delta = 1
				if(fieldConfig.reverseSwitchOrder){
					delta = -1
				}
				let nextSelectedChildIndex = (((this.model.selectedChildIndex * 1) || 0) + delta) % nrOfOptions
				if(nextSelectedChildIndex < 0) nextSelectedChildIndex += nrOfOptions;
				const option = this.model.options[nextSelectedChildIndex]

				if(option && nextSelectedChildIndex != this.model.selectedChildIndex){
					// toggle to next value
					this.select(option.value, fieldIsDisabled, true)
				}
			}
		},

		toggle(){
			const fieldConfig = this.model.config || {}
			if(fieldConfig.slimSwitch || fieldConfig.singleButtonSwitch){
				this.select(this.model.value)
			}
		},

		updateKeyDownLabelValue: function(value){
			var self = this;
			if(self.model.config.keyDownLabel || self.model.config.keyDownLabelTriggerOnly){
				self.parentComponents(undefined, function(parentComponent){
					if(utils.isFunction(parentComponent.updateKeyDownLabelValue)){
						self.model.keyDownLabel = parentComponent.updateKeyDownLabelValue(self.model.fieldCode, self.model.config, value, self);
						return false
					}
				});

				if(self.model.config.keyDownLabel && self.$){
					self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
				}
			}
		},

		disable: function(){
			this.model.isDisabled = true
			this.$.addClass('isDisabled')
		},

		enable: function(){
			this.model.isDisabled = false
			this.$.removeClass('isDisabled')
		},

		setDisabledValues(disabledValues){
			this.model.disabledValues = disabledValues || {}
			this.refresh(false)
		}
	},

	hooks: {
		attach: function($element, options){
			// if(utils.isEmpty(this.model.$options) || this.model.$options.length < 1){
				this.model.$options = $element.find('.toggleOption');
			// }
		},

		updateKeyDownLabelValue: function($element, options){
			var self = this;
			if(self.model.config.keyDownLabel && self.$ && options.value){
				self.model.keyDownLabel = options.value;
				self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
			}
		}
	}
};
